import React, { useEffect, useState } from "react";
import { db } from "../firebase/firestore"; // Adjust the import based on your file structure
import { doc, getDoc, updateDoc, Timestamp } from "firebase/firestore";
import { useUser } from "../context/userContext";
import { RiArrowRightSLine, RiSettings4Fill } from "react-icons/ri";
import Levels from "../Components/Levels";
import SettingsMenu from "../Components/SettingsMenu";
import { PiLockKeyFill } from "react-icons/pi";
import { FaCalendarAlt } from "react-icons/fa";
import { IoCheckmarkCircleSharp } from "react-icons/io5";
import { FaSpinner } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const DailyCheckIn = () => {
  const {
    id,
    fullName,
    tapBalance,
    setLastCheckIn,
    lastCheckIn,
    error,
    setError,
    checkInDays,
    setCheckInDays,
    userLevelss,
    loginCount,
    username,
    setLoginCount,
    balance,
    refBonus,
    setEnergy,
  } = useUser();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showLevel, setShowLevel] = useState(false);
  const [showSetting, setShowSetting] = useState(false);
  const [claiming, setClaiming] = useState(null);
  const [congrats, setCongrats] = useState(false);

  const handleDailyCheckIn = async (dayIndex) => {
    if (!id) return;

    const now = new Date();
    const lastCheck = lastCheckIn ? lastCheckIn : null;

    setClaiming(dayIndex);
    setError(null);
    setShowSuccessModal(false);

    try {
      const userDocRef = doc(db, "telegramUsers", id);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();

        // Calculate days since last check-in
        let daysSinceLastCheck = 0;
        if (lastCheck) {
          daysSinceLastCheck = Math.floor(
            (now - lastCheck) / (1000 * 60 * 60 * 24)
          );
        }

        // Reset streak if more than 24 hours have passed
        let newLoginCount;
        if (daysSinceLastCheck > 1 || !lastCheck) {
          // Reset to day 1 if more than 1 day has passed or first time
          newLoginCount = 1;
        } else if (daysSinceLastCheck < 1) {
          // Less than 24 hours since last check-in
          setError("You can only check in once every 24 hours.");
          setClaiming(false);
          return;
        } else {
          // Exactly 1 day has passed - continue streak
          newLoginCount = (userData.loginCount || 0) + 1;
        }

        // Calculate energy reward based on streak
        const newEnergy =
          newLoginCount === 1
            ? 5
            : newLoginCount === 2
            ? 10
            : newLoginCount === 3
            ? 15
            : newLoginCount === 4
            ? 20
            : newLoginCount === 5
            ? 25
            : newLoginCount === 6
            ? 30
            : newLoginCount >= 8
            ? 35
            : 35;

        // Update database
        await updateDoc(userDocRef, {
          lastCheckIn: Timestamp.fromDate(now),
          checkInDays: newLoginCount - 1,
          loginCount: newLoginCount,
          energy: (userData.energy || 0) + newEnergy,
        });

        // Update UI states
        setShowSuccessModal(true);
        setCongrats(true);
        setTimeout(() => {
          setCongrats(false);
        }, 4000);

        setLastCheckIn(now);
        setEnergy((prevEnergy) => (prevEnergy || 0) + newEnergy);
        setCheckInDays(newLoginCount - 1);
        setLoginCount(newLoginCount);
      }
    } catch (err) {
      console.error("Error during daily check-in:", err);
      setError(err.message);
    } finally {
      setClaiming(false);
    }
  };

  const handleDayEightCheckin = async () => {
    if (checkInDays < 7) {
      setError(
        "You must complete 7 consecutive check-ins to unlock the Day 8+ reward."
      );
      return;
    }

    try {
      const userDocRef = doc(db, "telegramUsers", id);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();
        const now = new Date();

        // Calculate energy reward for Day 8+
        const newEnergy = 35;

        await updateDoc(userDocRef, {
          lastCheckIn: Timestamp.fromDate(now),
          checkInDays: userData.checkInDays + 1,
          loginCount: (userData.loginCount || 0) + 1,
          energy: (userData.energy || 0) + newEnergy,
        });

        setLastCheckIn(now);
        setEnergy((prevEnergy) => (prevEnergy || 0) + newEnergy);
        setCheckInDays(userData.checkInDays + 1);
        setLoginCount((prevCount) => prevCount + 1);
        setShowSuccessModal(true);
        setCongrats(true);
        setTimeout(() => {
          setCongrats(false);
        }, 4000);
      }
    } catch (err) {
      console.error("Error during Day 8+ check-in:", err);
      setError(err.message);
    } finally {
      setClaiming(false);
    }
  };

  const formatNumber = (num) => {
    if (num < 100000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else if (num < 1000000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else {
      return (num / 1000000).toFixed(3).replace(".", ".") + " M";
    }
  };

  const navigate = useNavigate();

  console.log("Handling daily check-in for day index:", loginCount);
  // console.log("Check-in successful, updated user data", checkInDays.length);
  const initialLevelIndex = userLevelss.findIndex(
    (level) => tapBalance < level.tapBalanceRequired
  );
  const currentLevelIndex =
    initialLevelIndex === -1 ? userLevelss?.length - 1 : initialLevelIndex;

  const displayedLevelIndex = currentLevelIndex;
  const currentLevel = userLevelss[displayedLevelIndex];

  const renderCheckInBoxes = () => {
    const spins = Array.from({ length: 7 }, (_, i) => `${i + 1}`);
    const today = new Date();

    const daysSinceLastCheck = lastCheckIn
      ? Math.floor((today - lastCheckIn) / (1000 * 60 * 60 * 24))
      : 0;

    // Reset visual streak if more than 1 day has passed
    const effectiveLoginCount = daysSinceLastCheck > 1 ? 0 : loginCount;

    return spins.map((spin, index) => {
      const isCheckedIn = checkInDays === index;
      const isActive = effectiveLoginCount === index;

      return (
        <>
          <button
            key={index}
            disabled={isCheckedIn}
            className={`w-[23%] space-y-1 flex flex-col items-center justify-center relative h-[80px] rounded-[8px] cursor-pointer select-none 
            ${index < effectiveLoginCount ? "!bg-blue-700" : ""}
                    ${effectiveLoginCount === index ? "bg-green-700" : ""}
                    ${!isActive ? "bg-cards" : ""}
                `}
            onClick={() => !isCheckedIn && handleDailyCheckIn(index)}
          >
            {claiming === index ? (
              <p>
                <FaSpinner />
              </p>
            ) : (
              <>
                <h2 className="text-[10px]">{`Day ${index + 1}`}</h2>
                <span className="text-[13px] font-bold">x{spin * 5}</span>
                <span
                  className={`w-[6px] top-1 right-2 h-[6px] bg-white rounded-full ${
                    index < effectiveLoginCount ? "" : "hidden"
                  }`}
                />
              </>
            )}
          </button>
        </>
      );
    });
  };

  return (
    <>
      <div className="w-full flex justify-center flex-col">
        <div className="w-full flex items-center justify-between h-[55px] px-4 bg-[#000] border-b border-b-[2px] border-b-[#a71414]">
          <div className="w-[50%] flex items-center space-x-[6px]">
            <div
              className={`w-[30px] h-[30px] rounded-[8px] p-[2px] overflow-hidden flex items-center justify-center relative`}
            >
              <img
                src={currentLevel.icon}
                className={`w-[30px] mt-[6px]`}
                alt={fullName || "user"}
              />
            </div>
            <div className="w-[70%] flex flex-col space-y-1 pr-4">
              <div className="w-full flex justify-between text-[10px] font-medium items-center">
                <span className="levelName flex items-center">
                  <span onClick={() => setShowLevel(true)} className="">
                    {currentLevel.name}
                  </span>
                  <span className="flex items-center">
                    <RiArrowRightSLine size={12} className="mt-[1px]" />
                  </span>
                </span>
                <span className="">Chessy {username}</span>
              </div>
              <div className="flex w-full mt-2 items-center bg-[#56565630] rounded-[10px] border-[1px] border-[#49494952]">
                <div
                  className={`h-[6px] rounded-[8px] levelbar`}
                  style={{
                    width: `${
                      (tapBalance / currentLevel.tapBalanceRequired) * 100
                    }%`,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="flex w-[50%] mb-[-4px] rounded-full items-center justify-end">
            <div className="flex flex-col items-center justify-center">
              <p className="text-[9px]">Balance</p>
              <div className="flex items-center justify-center space-x-1 text-[11px]">
                <span className="flex items-center justify-center">
                  <img src="/coin.webp" alt="ppf" className="w-[10px]" />
                </span>
                <span className="font-bold">
                  {formatNumber(balance + refBonus)}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          id="refer"
          className="w-full flex flex-col scroller h-[100vh] overflow-y-auto pb-[180px] pt-3 px-4"
        >
          <div
            className={`w-full flex-col pb-4 flex items-center justify-center text-center pt-4`}
          >
            <span className="bg-cards h-[90px] w-[90px] rounded-full flex items-center justify-center">
              <FaCalendarAlt size={50} className="text-accent" />
            </span>
            <h1 className="text-[20px] font-semibold pt-2">
              Daily checkin rewards
            </h1>
            <p className="text-[14px] leading-[24px]">
              Accrue CHEESE tokens for logging into the game daily!
            </p>
            {lastCheckIn && (
              <p>
                {lastCheckIn.toLocaleDateString()}{" "}
                {lastCheckIn.toLocaleTimeString()}
              </p>
            )}
          </div>
          {error && <p className="text-red-500 w-full text-center">{error}</p>}
          <div className="w-full flex justify-center gap-2 flex-wrap">
            {renderCheckInBoxes()}
          </div>
          <div className="w-full flex justify-center mt-4">
            <button
              onClick={handleDayEightCheckin}
              className="w-[23%] space-y-1 border border-1 border-white/30 bg-cards flex flex-col items-center justify-center relative h-[80px] rounded-[8px] cursor-pointer select-none"
            >
              <h2 className="text-[10px]">{">"} Day 8</h2>
              <span className="text-[13px] font-bold">x35</span>
            </button>
          </div>

          <div className="w-full absolute top-[50px] flex justify-center z-50 pointer-events-none select-none">
            {congrats ? (
              <img src="/congrats.gif" alt="congrats" className="w-[80%]" />
            ) : (
              <></>
            )}
          </div>

          <div
            className={`${
              showSuccessModal === true ? "visible" : "invisible"
            } fixed top-[-12px] claimdiv bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#00000042] flex flex-col justify-center items-center px-4`}
          >
            <div
              className={`${
                showSuccessModal === true
                  ? "opacity-100 mt-0"
                  : "opacity-0 mt-[100px]"
              } w-full bg-modal rounded-[16px] relative flex flex-col ease-in duration-300 transition-all justify-center p-8`}
            >
              <div className="w-full flex justify-center flex-col items-center space-y-3">
                <div className="w-full items-center justify-center flex flex-col space-y-2">
                  <IoCheckmarkCircleSharp size={32} className="text-accent" />
                  <p className="font-medium">checkin bonus claimed</p>
                </div>
                <h3 className="font-medium text-[24px] text-[#ffffff] pt-2 pb-2">
                  <span className="text-accent">x{loginCount * 5} </span>Spins
                </h3>
                <p className="pb-6 text-[#bfbfbf] text-[15px] w-full text-center">
                  Daily check-in bonus claimed! <br />
                  Come back tomorrow to claim another checkin bonus!
                </p>

                <div className="w-full flex justify-center">
                  <button
                    onClick={() => {
                      setShowSuccessModal(false);
                      navigate("/");
                    }}
                    className="bg-btn4 w-fit py-[10px] px-6 flex items-center justify-center text-center rounded-[12px] font-medium text-[16px]"
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Levels showLevel={showLevel} setShowLevel={setShowLevel} />
      <SettingsMenu showSetting={showSetting} setShowSetting={setShowSetting} />
    </>
  );
};

export default DailyCheckIn;
